import { Pipe, PipeTransform } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
//import {  debounceTime, distinctUntilChanged } from 'rxjs/operator';


@Pipe({
    name: 'dataFilter',
    pure: true
})
export class DataFilterPipe implements PipeTransform {

    public transform(value: any, keys: string, term: string) {
        if (!term) return value;
        return (value || []).filter((item: any) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key].toString())));
    }



}
